module.exports = __webpack_public_path__ + "img/4.91d79c57.png";